// extracted by mini-css-extract-plugin
export default {"wrapper":"Z9EVV","icon":"Tsu1a","media-wrapper":"IOPzR","card":"qGZkc"};